type Armazenamento = Pick<Storage, "getItem" | "setItem" | "removeItem">;

export const ORGANIZACAO_ADMINISTRADA_ALTERADA_EVENT = "bp:organizacao-administrada-alterada";

export function chaveOrganizacaoAdministrada(usuarioId: string) {
  return `bp-programador:web-beta:organizacao-administrada:${usuarioId}`;
}

export function restaurarOrganizacaoAdministrada(
  armazenamento: Armazenamento,
  usuarioId: string,
  organizacoes: readonly { id: string }[],
  organizacaoSessaoId: string,
) {
  try {
    const chave = chaveOrganizacaoAdministrada(usuarioId);
    const salva = armazenamento.getItem(chave);
    if (salva === null) return organizacaoSessaoId;
    if (organizacoes.some((organizacao) => organizacao.id === salva)) return salva;
    armazenamento.removeItem(chave);
  } catch {
    // Storage pode estar indisponível; a organização da sessão continua sendo o fallback.
  }
  return organizacaoSessaoId;
}

export function persistirOrganizacaoAdministrada(armazenamento: Armazenamento, usuarioId: string, organizacaoId: string) {
  try {
    armazenamento.setItem(chaveOrganizacaoAdministrada(usuarioId), organizacaoId);
  } catch {
    // Selecionar a organização continua funcionando sem persistência local.
  }
}
